import {
  arrayOf as arrayType,
  string as stringType,
  shape as shapeType,
  params,
  extend
} from '@thd-nucleus/data-sources';
import { MediaGallery } from '@thd-olt-component-react/media-gallery';
import { VendorCollectionPod } from './subcomponents/VendorCollectionPod';

const mediaGalleryCollection = {
  collection: MediaGallery.dataModel.collection
};

const Section = extend({
  title: stringType(),
  isCarousel: stringType(),
  products: arrayType(shapeType({ itemId: stringType() }))
});

const Images = {
  url: stringType(),
  type: stringType()
};

const LinkedCollections = {
  id: stringType(),
  name: stringType(),
};

const AvailableOptions = {
  title: stringType(),
  linkedCollections: arrayType(shapeType(LinkedCollections))
};

const CollectionsContent = {
  title: stringType(),
  brand: stringType(),
  collectionType: stringType(),
  description: stringType(),
  section: arrayType(shapeType(Section)),
  availableOptions: AvailableOptions,
  media: shapeType({
    images: arrayType(shapeType(Images))
  }),
  taxonomy: shapeType({
    breadCrumbs: arrayType(shapeType({
      label: stringType(),
      url: stringType()
    }))
  })
};

const vendorCollectionDataModel = {
  fetchCollectionsContent: params({ collectionName: stringType().isRequired() }).shape(CollectionsContent),
  searchModel: params({
    itemIds: arrayType(stringType()).isRequired(),
    storeId: stringType().isRequired()
  }).shape({
    products: arrayType(shapeType(VendorCollectionPod.dataModel.product))
  }),
};

export const VendorCollectionDataModel = extend(
  vendorCollectionDataModel,
  mediaGalleryCollection,
  VendorCollectionPod.dataModel
);
